import React from 'react';

/**
 * Indicador de "digitando..." com animacao de bolinhas
 */
const ChatbotTypingIndicator = () => {
  return (
    <div className="chatbot-message chatbot-message-assistant">
      <div className="chatbot-message-avatar">P</div>
      <div className="chatbot-message-bubble chatbot-typing-bubble">
        <div className="chatbot-typing-indicator">
          <span className="chatbot-typing-dot" />
          <span className="chatbot-typing-dot" />
          <span className="chatbot-typing-dot" />
        </div>
      </div>
    </div>
  );
};

export default ChatbotTypingIndicator;
